import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@codes/ui-kit/components/ui/alert';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@codes/ui-kit/components/ui/alert-dialog';
import { AlertCircle } from 'lucide-react';

import { CopyButton } from './CopyButton';

interface AccessKeySuccessDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    credential: {
        accessKey: string;
        secretKey: string;
    };
}

export const AccessKeySuccessDialog = ({ open, onOpenChange, credential }: AccessKeySuccessDialogProps) => {
    const { t } = useTranslation();

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('accessKeys.successDialog.title')}</AlertDialogTitle>
                    <AlertDialogDescription>{t('accessKeys.successDialog.description')}</AlertDialogDescription>
                </AlertDialogHeader>
                <div className="my-4 space-y-4">
                    <div className="space-y-2">
                        <label className="text-xs font-medium text-muted-foreground">Access Key</label>
                        <div className="flex items-center gap-2 rounded-md bg-muted p-3">
                            <code className="flex-1 font-mono text-sm break-all">{credential.accessKey}</code>
                            <CopyButton value={credential.accessKey} />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="text-xs font-medium text-muted-foreground">Secret Key</label>
                        <div className="flex items-center gap-2 rounded-md bg-muted p-3">
                            <code className="flex-1 font-mono text-sm break-all">{credential.secretKey}</code>
                            <CopyButton value={credential.secretKey} />
                        </div>
                    </div>
                    <Alert variant="default">
                        <AlertCircle className="h-4 w-4" />
                        <AlertDescription>{t('accessKeys.successDialog.warning')}</AlertDescription>
                    </Alert>
                </div>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={() => onOpenChange(false)}>
                        {t('accessKeys.successDialog.confirm')}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
